import React from 'react';

import _ from '../locale';
import SubmitModal, { Props as SubmitModalProps } from './SubmitModal';

export type Props = {
    message: string | JSX.Element;
} & SubmitModalProps;

const ConfirmationModal: React.FC<Props> = ({ message, submitLabel, ...restProps }) => (
    <SubmitModal {...restProps} submitLabel={submitLabel || _('cancel_confirmation_button')}>
        {message}
    </SubmitModal>
);

export default ConfirmationModal;
